var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"issue-new-card",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"pulse-button"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("person_add")]),_vm._v("Add New")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }